import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import GalleryService from '@/services/gallery.service';
import AddArticleForm from '@/shared-components/forms/add-board-content/add-article';
import Loader from '@/shared-components/loader/Loader';
import { canAccessGalleryPermission } from '@/utils/galleryPermissions';

export default function EditArticle() {
  const { articleId } = useParams();
  const { state } = useStateHandler();
  const session = state.user_session;
  const sessionType = String(session?.user_type ?? session?.__t ?? "").toLowerCase();
  const canEditArticle = sessionType === "artist"
    || !session?.gallery_id
    || canAccessGalleryPermission(session, "board.article", session?.gallery_id);

  // Enhanced: allow forceFresh to always get latest from server if needed
  const [{
    loading,
    error,
    data,
  }, setArticleFetched] = useState({
    loading: true,
    error: null,
    data: null,
  });

  useEffect(() => {
    GalleryService.getArticleById(articleId)
      .then(response => {
        setArticleFetched({
          loading: false,
          data: response.data,
          error: null,
        });
      })
      .catch(() => {
        setArticleFetched({
          loading: false,
          data: null,
          error: null,
        });
      });

  }, []);

  if (!canEditArticle) return <Navigate to="/profile/board" replace />;
  if (loading) return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Loader />
    </div>
  ); 
  if (!data ) return <Navigate to="/profile/board" replace />;

  // TODO: Pablo añadir pagina error
  if(error) {
    return "ERROR";
  }

  return <AddArticleForm postData={data} editMode={true} />;
}
